import * as React from 'react';
import { Form } from 'formik';
import styled from 'styled-components';
import { space, width, height, flex, color, borderRadius, flexDirection, flexWrap, alignItems } from 'styled-system';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import tag from 'blacklist-tag';

interface Props extends StyledSystemProps {
  bg?: string;
  type?: string;
  name?: string;
  width?: string;
  color?: string;
  height?: string;
  placeholder?: string;
  children: React.ReactNode;
  borderRadius?: string | number;
}

const CleanForm = tag(Form, ['flexDirection', 'alignItems', 'flexWrap', 'maxWidth']);

const FormWrap = styled(CleanForm)`
  ${flex};
  ${space};
  ${width};
  ${color};
  ${height};
  ${flexWrap};
  ${alignItems};
  ${borderRadius};
  ${flexDirection};
  display: flex;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: ${(props: Props) => (props.bg === 'transparent' ? 'none' : '0 0px 4px -1px rgba(50,50,93,0.3)')};
`;

const StyledForm: React.FC<Props> = (props: Props) => {
  return <FormWrap {...props}>{props.children}</FormWrap>;
};

export default StyledForm;

StyledForm.defaultProps = {
  width: '100%',
  height: 'auto',
  bg: 'transparent',
  flexDirection: 'column',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
};



// WEBPACK FOOTER //
// ./src/components/formElements/StyledForm.tsx